// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentModelResponse {
    static getAttributeTypeMap() {
        return DocumentModelResponse.attributeTypeMap;
    }
}
DocumentModelResponse.discriminator = undefined;
DocumentModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "DocumentModel"
    }
];
//# sourceMappingURL=documentModelResponse.js.map